import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ModalService } from '../../services/modal.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { DeParaGeneric } from '../../model/deparageneric';
import { CadastrosService } from '../../services/cadastros.service';

@Component({
  selector: 'app-deparageneric',
  templateUrl: './deparageneric.component.html',
  styleUrls: ['./deparageneric.component.scss']
})
export class DeParaGenericComponent implements OnInit {

  movSub: Subscription;
  deparageneric: any[];
  fileReader: FileReader;
  fileToRead: File;

  constructor(
      private spinner: NgxSpinnerService,
      private modalService: ModalService,
      private cadastrosService: CadastrosService,
      private toastr: ToastrService,
      private confirmationDialogService: ConfirmationDialogService
  ){

  }

  ngOnInit() {
    this.getdeparagenerics();
  }

  async getdeparagenerics(){

    this.deparageneric = [];

    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }

    if (!this.movSub || this.movSub.closed){

      this.spinner.show();

      this.movSub = this.cadastrosService.listar("deparageneric/list").subscribe(
        (result: any) =>{

          this.deparageneric =  result;
          console.log(result);

          this.spinner.hide();

       },error=>{
            console.log(error);
            this.spinner.hide();
       });

    }


  }

  ngOnDestroy(){
    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }
  }

  novodeparageneric(){
    this.modalService.modalDetalhesDeParaGeneric.emit(null);
  }

  editar(deparageneric: DeParaGeneric){
    this.modalService.modalDetalhesDeParaGeneric.emit(deparageneric);
  }

  excluir(deparageneric: DeParaGeneric){

    this.confirmationDialogService.confirm('Confirmar?', 'Realmente deseja excluir ?')
      .then((confirmed) =>{

        if(confirmed){
          this.cadastrosService.excluir("deparageneric/delete", deparageneric).subscribe(
            (result) =>{

              this.toastr.success('DeParaGeneric excluído com sucesso!', 'Sucesso!');
              this.getdeparagenerics();
              console.log(result);

            },
            error=> {

              this.toastr.error(error.message, 'Erro!');
              console.log(error);

            }
          );
        }

      })
      .catch(() => {
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });

  }


}
